import React from "react";
import { motion } from "framer-motion";
import { Mail, ArrowUpRight, MapPin, Phone } from "lucide-react";

const Contact = () => {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="bg-[#0a0a0a] text-white relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32">
        <div className="flex items-center gap-3 mb-8">
          <span className="font-mono text-xs text-[#5b8bff]">[ 10 ]</span>
          <span className="text-xs uppercase tracking-[0.25em] font-semibold text-[#5b8bff]">
            Let&apos;s Talk
          </span>
        </div>

        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          data-testid="contact-heading"
          className="font-display text-[3rem] sm:text-7xl lg:text-9xl xl:text-[10rem] font-black tracking-tighter leading-[0.98] sm:leading-[0.95] mb-10 break-words"
        >
          Build with
          <br />
          <span className="italic font-medium text-[#5b8bff]">us.</span>
        </motion.h2>

        <p className="text-lg lg:text-xl text-white/75 max-w-xl leading-relaxed mb-14">
          Tell us about the operating problem you&apos;re solving. We&apos;ll
          come back with a sharp first read and a clear next step.
        </p>

        <a
          href="mailto:hello@intelvolks.com"
          data-testid="contact-email-cta"
          className="group inline-flex flex-wrap items-center gap-4 border-b-2 border-white pb-3 mb-8 hover:border-[#5b8bff] transition-colors"
        >
          <Mail className="w-7 h-7 lg:w-9 lg:h-9" strokeWidth={1.5} />
          <span className="font-display text-3xl sm:text-5xl lg:text-7xl font-black tracking-tighter group-hover:text-[#5b8bff] transition-colors">
            hello@intelvolks.com
          </span>
          <ArrowUpRight
            className="w-7 h-7 lg:w-10 lg:h-10 group-hover:rotate-12 transition-transform"
            strokeWidth={1.5}
          />
        </a>

        <a
          href="tel:+919866607253"
          data-testid="contact-phone-cta"
          className="group inline-flex flex-wrap items-center gap-4 border-b-2 border-white/30 pb-3 mb-16 hover:border-[#5b8bff] transition-colors"
        >
          <Phone className="w-6 h-6 lg:w-8 lg:h-8" strokeWidth={1.5} />
          <span className="font-display text-2xl sm:text-4xl lg:text-5xl font-black tracking-tighter group-hover:text-[#5b8bff] transition-colors">
            +91 98666 07253
          </span>
          <ArrowUpRight
            className="w-6 h-6 lg:w-8 lg:h-8 group-hover:rotate-12 transition-transform"
            strokeWidth={1.5}
          />
        </a>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-px bg-white/15 border border-white/15">
          <div data-testid="contact-block-email" className="bg-[#0a0a0a] p-8">
            <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#5b8bff] mb-3">
              Email
            </div>
            <a
              href="mailto:hello@intelvolks.com"
              className="iv-link font-display text-lg font-bold break-all"
            >
              hello@intelvolks.com
            </a>
          </div>
          <div data-testid="contact-block-phone" className="bg-[#0a0a0a] p-8">
            <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#5b8bff] mb-3">
              Phone
            </div>
            <a
              href="tel:+919866607253"
              className="iv-link font-display text-lg font-bold"
            >
              +91 98666 07253
            </a>
          </div>
          <div data-testid="contact-block-focus" className="bg-[#0a0a0a] p-8">
            <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#5b8bff] mb-3">
              Focus
            </div>
            <div className="font-display text-lg font-bold">
              Edutech &amp; Food-tech enterprises
            </div>
          </div>
          <div data-testid="contact-block-engage" className="bg-[#0a0a0a] p-8">
            <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#5b8bff] mb-3">
              Engage
            </div>
            <div className="font-display text-lg font-bold">
              Long-term partnership model
            </div>
          </div>
        </div>
      </div>

      <footer className="border-t border-white/15">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="flex items-center gap-2">
            <span className="font-display text-xl font-black tracking-tighter">
              Intelvolks
            </span>
            <span className="block w-1.5 h-1.5 bg-[#0038FF]" />
          </div>
          <div className="text-xs text-white/55 font-mono uppercase tracking-[0.2em]">
            © {new Date().getFullYear()} Intelvolks. All rights reserved.
          </div>
          <div className="flex items-center gap-6 text-xs uppercase tracking-[0.2em] font-semibold">
            <a
              href="#home"
              data-testid="footer-top-link"
              className="iv-link text-white/75 hover:text-white"
            >
              Back to top
            </a>
          </div>
        </div>
      </footer>
    </section>
  );
};

export default Contact;
